import type { HTMLAttributes } from "react"

import { cn } from "@/lib/utils"

type BadgeProps = HTMLAttributes<HTMLDivElement> & {
  variant?: "default" | "outline" | "muted" | "secondary" | "destructive"
}

export function Badge({ className, children, variant = "default", ...props }: BadgeProps) {
  const base =
    "inline-flex items-center rounded-[var(--radius-full)] border px-[var(--space-md)] py-[var(--space-xs)] text-xs font-semibold uppercase tracking-[0.25em]"
  const styles = {
    default: "border-border/60 bg-secondary text-foreground",
    outline: "border-border/70 bg-transparent text-foreground",
    muted: "border-border/60 bg-muted/60 text-muted-foreground",
    secondary: "border-transparent bg-foreground text-background",
    destructive: "border-transparent bg-[color-mix(in_oklab,var(--token-surface-danger)_45%,transparent)] text-background",
  }

  return (
    <div className={cn(base, styles[variant], className)} {...props}>
      {children}
    </div>
  )
}
